import { Address } from '@ton/core'

export const normalizeTonAddress = (input: string | null | undefined): string => {
  if (!input) return ''
  try {
    return Address.parse(input).toString({ bounceable: false, testOnly: false })
  } catch {
    return input
  }
}
